import { Component, OnInit } from '@angular/core';
import { gungAddRemoveSpinner } from 'gung-standard';
import { Claim } from '../../../services/colmec-claim.service';
import { ColmecModalService } from '../../../services/colmec-modal.service';
import { ColmecClaimGridViewComponent } from '../colmec-claim-grid-view/colmec-claim-grid-view.component';

@Component({
    selector: 'colmec-claim-table-view',
    templateUrl: './colmec-claim-table-view.component.html',
    styleUrls: ['./colmec-claim-table-view.component.scss'],
    standalone: false
})
export class ColmecClaimTableViewComponent extends ColmecClaimGridViewComponent implements OnInit {
  constructor(protected colmecModalService: ColmecModalService) {
    super();
  }

  ngOnInit(): void {}

  viewClaim(claim: Claim, element) {
    const target = element.target;
    gungAddRemoveSpinner(target);
    this.colmecModalService
      .openClaimModal(null, claim)
      .then(
        answer => {
          console.log('answer', answer);
          if (answer) {
            gungAddRemoveSpinner(target);
          } else {
            gungAddRemoveSpinner(target);
            // this.gungModalService.openConfirmYesNoModal(undefined, 'ERROR', { size: 'sm' }, 'OK', null).then(_ => { });
          }
        },
        error => {
          gungAddRemoveSpinner(target);
          // this.gungModalService.openConfirmYesNoModal(undefined, 'ERROR', { size: 'sm' }, 'OK', null).then(_ => { });
        }
      )
      .catch(res => gungAddRemoveSpinner(target));
  }
}
